import { sendTrackingIdentity } from '@/scripts/tracking-util';
import { setConsentCookie } from '@/scripts/consent-cookie';

export const PERMISSION = {
  NECESSARY: 'necessary',
  FUNCTIONAL: 'functional',
  PERFORMANCE: 'performance',
  TARGETING: 'targeting',
  ANALYTICS: 'analytics',
};

export default function useEnzuzo() {
  function hasPermission(value) {
    return value === true;
  }

  function handleAcceptAll() {
    console.log('handleAcceptAll');
    sendTrackingIdentity({}, { permission: PERMISSION.FUNCTIONAL });
    setConsentCookie(true);
    console.log('setting vwo to 1');
  }

  function handleRejectAll() {
    console.log('handleRejectAll');
    sendTrackingIdentity({}, { permission: PERMISSION.NECESSARY });
    setConsentCookie(false);
    console.log('setting vwo to 3');
  }

  function handleAcceptSome(preferences) {
    console.log('handleAcceptSome', preferences);
    if (Object.values(preferences).every(el => hasPermission(el))) {
      sendTrackingIdentity({}, { permission: PERMISSION.FUNCTIONAL });
    } else {
      sendTrackingIdentity({
        permission: {
          ...(preferences.analytics ? { [PERMISSION.ANALYTICS]: true } : {}),
          ...(preferences.marketing ? { [PERMISSION.TARGETING]: true } : {}),
          ...(preferences.preferences ? { [PERMISSION.PERFORMANCE]: true } : {}),
        },
      });
    }
    setConsentCookie(JSON.stringify(preferences));
  }

  // eslint-disable-next-line no-unused-vars
  function onInit(preferences) {
    console.log('onInit', preferences);
    const acceptAll = Object.values(preferences).every(value => hasPermission(value));

    if (acceptAll) {
      handleAcceptAll();

      return;
    }

    const rejectAll = Object.values(preferences).every(value => !hasPermission(value));

    if (rejectAll) {
      handleRejectAll();

      return;
    }

    handleAcceptSome({
      analytics: hasPermission(preferences.analytics),
      marketing: hasPermission(preferences.marketing),
      preferences: hasPermission(preferences.preferences),
      functional: hasPermission(preferences.functional),
    });
  }

  function configureEnzuzo() {
    console.log('inside configure enzuzo');
    window.__enzuzoConfig = window.__enzuzoConfig || {};
    window.__enzuzoConfig.callbacks = {
      // init(preferences) {
      //   onInit(preferences);
      // },
      acceptSelected(preferences) {
        handleAcceptSome(preferences);
      },
      acceptAll() {
        handleAcceptAll();
      },
      decline() {
        handleRejectAll();
      },
    };
    if (!window.hasNotGivenPreviousConsent) {
      console.log('dont show mode');
      window.__enzuzoConfig.bannerMode = 'dontshow';
    }
    // Inject script into head
    const script = document.createElement('script');
    script.src = 'https://app.enzuzo.com/scripts/cookiebar/1db41aa2-4a72-11ef-b97c-6b30db968ac5';
    script.async = true;
    script['auto-blocking'] = 'allow';
    document.head.appendChild(script);
  }

  return {
    configureEnzuzo,
  };
}
